export const makeStyles = (hasSubmittedBuildName, isValid) => {
  return {
    card: {
      backgroundColor: 'white',
      border: '1px solid #ddd',
      borderRadius: '8px',
      width: '200px',
      height: '100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '10px',
      padding: '20px',
      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.2s',
      '&:hover': {
        transform: 'scale(1.05)',
      },
      textAlign: 'center',
    },
    cardContainer: {
      padding: '16px',
      marginTop: '16px',
      width: '100%',
      height: '300px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      overflow: 'auto',
      marginBottom: '36px',
      paddingBottom: '36px',
    },
    container: {
      padding: '24px',
      maxWidth: '90%',
      margin: 'auto',
    },
    title: {
      fontWeight: 'bold',
      marginBottom: '24px',
    },
    filterSection: {
      display: 'flex',
      gap: '8px',
      marginBottom: '16px',
    },
    addBuildSection: {
      display: 'flex',
      gap: '8px',
      marginBottom: '16px',
    },
    button: {
      padding: '8px 16px',
      border: '1px solid #007BFF',
      backgroundColor: 'white',
      color: '#0053B3',
      cursor: 'pointer',
      borderRadius: '4px',
      transition: 'background-color 0.2s',
    },
    buttonBuild: {
      padding: '8px 16px',
      border: '1px solid hsl(138, 100%, 35%)',
      backgroundColor: 'white',
      color: 'hsl(138, 100%, 35%)',
      cursor: 'pointer',
      borderRadius: '4px',
      transition: 'background-color 0.2s',
    },
    buttonBuildHover: {
      backgroundColor: 'hsl(138, 100%, 35%)',
      color: 'hsl(138, 100%, 95%)',
    },
    buttonMlp: {
      padding: '8px 16px',
      border: '1px solid hsl(211, 100%, 50%)',
      backgroundColor: 'white',
      color: 'hsl(211, 100%, 50%)',
      cursor: 'pointer',
      borderRadius: '4px',
      transition: 'background-color 0.2s',
    },
    buttonMlpHover: {
      backgroundColor: 'hsl(211, 100%, 50%)',
      color: 'hsl(211, 100%, 95%)',
    },
    tableContainer: {
      marginTop: '14px',
      overflowY: 'auto',
      overflowX: 'auto',
      width: '100%',
      border: '1px solid #ddd',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
    },
    th: {
      padding: '12px 16px',
      textAlign: 'left',
      backgroundColor: '#f4f6f8',
      color: '#333',
      fontWeight: 'bold',
      fontSize: '14px',
      borderBottom: '2px solid #ddd',
      position: 'sticky',
      top: '0',
      zIndex: 1,
    },
    td: {
      padding: '12px 16px',
      textAlign: 'left',
      color: '#555',
      fontSize: '14px',
      borderBottom: '1px solid #eee',
      transition: 'background-color 0.2s',
      '&:hover': {
        backgroundColor: '#f9f9f9',
      },
    },
    input: {
      padding: '10px',
      width: '250px',
      marginRight: '8px',
      border: `2px solid ${
        hasSubmittedBuildName ? (isValid ? 'green' : 'red') : 'rgb(204, 204, 204)'
      }`,
      borderRadius: '4px',
      outline: 'none',
    },
    dropdown: { border: '1px solid #ccc', maxHeight: '150px', overflowY: 'auto' },
    dropdownItem: { padding: '8px', cursor: 'pointer' },
    toggleButton: { marginTop: '10px', padding: '8px' },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderBottom: '2px solid #dee2e6',
      marginBottom: '24px',
    },
    category: {
      margin: '0 10px',
      fontWeight: 'bold',
    },
    banner: {
      padding: '10px',
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      borderRadius: '5px',
      marginBottom: '20px',
    },
    metadataItem: {
      display: 'flex',
      justifyContent: 'space-between',
      margin: '5px 0',
    },
    label: {
      fontWeight: 'bold',
    },
    value: {
      color: '#333',
    },
    buttonDelete: {
      padding: '8px 16px',
      border: '1px solid #007BFF',
      backgroundColor: 'white',
      color: '#0053B3',
      cursor: 'pointer',
      borderRadius: '4px',
      transition: 'background-color 0.2s',
      float: 'left',
      margin: '10px 0',
    },
  };
};
